export default __webpack_public_path__ + "static/media/banner-new.513f3b34.jpg";